// src/hooks/useStickyNavbar.js
import { useEffect } from "react";

export default function useStickyNavbar(selector = ".navbar-desctop") {
  useEffect(() => {
    const navbar = document.querySelector(selector);
    if (!navbar) return; // nothing to do

    const onScroll = () => {
      if (window.scrollY > 320) {
        navbar.classList.add("affix", "animated", "slideInDown");
      } else {
        navbar.classList.remove("affix", "animated", "slideInDown");
      }
    };

    // run once immediately in case the page is already scrolled
    onScroll();

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [selector]);
}
